const hasHttpProtocol = (url = '') => ['http://', 'https://'].some(protocol => url.startsWith(protocol));
const hasSchemelessProtocol = (url = '') => ['//'].some(protocol => url.startsWith(protocol));

export function formatUrl(url:string) {
    // check for http(s)
    if(hasHttpProtocol(url)) {
        return url;
    }

    // check for schemaless
    if(hasSchemelessProtocol(url)) {
        return `http:${url}`;
    }

    return `http://${url}`;
}
